import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, Row, Col, Spin, Form, Radio,
    DatePicker,
    Select,
    Button,
    Input,
    InputNumber
} from 'antd';

//import { Select, Input } from 'antd';
import { formItemLayout, formatFormData } from './utils';
import {
    editTaskOverflowStatus, ayncSetTaskOverFlow, getList,

    //getList,
    //createbulkUpdateShowTaskAction,
    // bulkToMD,
    // getProvinceList,
    // getCurveList,
    // getPrimaryAndOtherScript,
    // getClusterList,
    // getOutTaskCategoryList,
    // getAgentsAndAreas,
    // createSetTaskIdListAction,
    // getLabelList,
    // getMonitorList
} from "./actions";

let user = JSON.parse(localStorage.getItem('HippoUserInfo'));
import TimePairsSelect from './TimePairsSelect.js';
const RangePicker = DatePicker.RangePicker;
import BehaviourMask from './changeBehaviour';

import moment from "../../client/commendList/utils";
const FormItem = Form.Item;
const { TextArea } = Input;
const RadioGroup = Radio.Group;

class EditOverFlow extends React.Component {

    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            role: user.role || 0,
            taskSource: '',
            engine: '',
            behaviourData: '',
            editBehavior: false,
            androidRatio: undefined,
            taskType: 'CLICK',
        };
    }

    handleCancel = () => {
        this.props.form.resetFields();
        this.props.editTaskOverflowStatus(false);
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            console.log('values--', values);
            //values.behaviourData = this.state.behaviourData;
            if (!err) {
                try {
                    //去掉检测公司属性中的空
                    if (values.monitorNames != undefined) {
                        values.monitorNames = values.monitorNames.filter((label, index) => {
                            return label != '空';
                        });
                    }
                    values.taskIds = this.props.taskIdList;
                    values.behaviourData = this.state.behaviourData;
                    if (this.state.androidRatio) {
                        values.androidRatio = this.state.androidRatio;
                        values.iosRatio = 100 - this.state.androidRatio;
                    }
                    if (values.beginTime && values.endTime) {
                        values.beginTime = values.beginTime.format('HH:mm');
                        values.endTime = values.endTime.format('HH:mm');
                        values.timePairs = [
                            {
                                beginTime: values.beginTime.replace(':', ''),
                                endTime: values.endTime.replace(':', ''),
                            },
                        ];
                    }
                    if (values.timePairs.length === 1) {
                        // 时间段可能没有被修改需要去掉这个参数
                        const { beginTime, endTime } = values.timePairs[0];
                        if (beginTime == endTime) {
                            delete values.timePairs;
                        }
                    }
                    values.overflowRate =
                        this.state.overflowRate == 40
                            ? parseInt(values.overflow)
                            : values.overflowRate == null
                                ? null
                                : parseInt(this.state.overflowRate);
                    //await this.props.bulkUpdate(values); 调用批量修改的地方
                    await this.props.form.resetFields();
                    await this.setState({
                        taskSource: '',
                        engine: '',
                        behaviourData: '',
                        editBehavior: false,
                        androidRatio: null,
                    });
                    //await this.props.getList(this.props.listState); //调用list任务集合的地方 
                } catch (err) {
                    console.log(err);
                    alert(err);
                }


                // for (let i in values) {
                //     if ("forceInteraction" != i && !values[i]) {
                //         delete values[i];
                //     }
                // }
                await this.props.ayncSetTaskOverFlow(formatFormData(values));
                this.props.form.resetFields();
                this.props.editTaskOverflowStatus(false);
                this.props.searchBegin();
            } else {
                console.log(err);
            }
        });
    };

    async handleChange(value) {
        await this.setState({
            ...this.state,
            taskType: value,
        });
    }
    changeFlow = e => {
        this.setState({
            ...this.state,
            overflowRate: e.target.value,
        });
    };

    handleEngine(value) {
        this.setState({
            engine: value,
        });
    }

    changeTaskSource = e => {
        this.setState({
            ...this.state,
            taskSource: e.target.value,
        });
    };

    changeAndroidRatio(value) {
        console.log(value);
        this.setState({
            ...this.state,
            androidRatio: value,
        });
    }
    showBehaviourEdit = () => {
        // 显示编辑行为数据的层
        if (this.state.behaviourData) {
            this.setState({ editBehavior: true });
        } else {
            message.error('转换的数据为空');
        }
    };
    hideBehaviorMask = () => {
        this.setState({ editBehavior: false });
    };
    changeBehaviourData = e => {
        this.setState({ behaviourData: e.target.value });
    };
    changeEditInfo = data => {
        this.setState(data);
    };

    render() {
        const {
            accountList,
            moniterNameList,
            taskIdList,
            bulkStatus,
            provinceList,
            primaryScripts,
            curveList,
            otherScripts,
            clusterList,
            outTaskCategoryList = [],
            agents,
            labelList,
            userList,
        } = this.props;
        const { editBehavior, taskType } = this.state;

        let moniterNameListClone = Array.from({});
        for (let i = 0; i < moniterNameList.length; i++) {
            moniterNameListClone[i] = moniterNameList[i];
        }
        moniterNameListClone.push({ monitoringName: '空' });


        const formItemLayout = {
            labelCol: {
                xs: { span: 18 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 14 },
            },
        };

        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (

            <Form>
                <div>
                    <Row>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="eId(筛选条件)">
                                {getFieldDecorator('eId', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入eId ',
                                        },
                                    ],
                                })(
                                    <Input placeholder="请填写" style={{ width: '100%' }} />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="任务类型(筛选条件)">
                                {getFieldDecorator('taskType', {
                                    rules: [{ required: false, message: '请选择类型' }],
                                })(
                                    <Select  onChange={this.handleChange.bind(this)}>
                                        <Option value="EV">曝光</Option>
                                        <Option value="CLICK">点击</Option>
                                        <Option value='APPLAUNCH'>APP拉起</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="排期(筛选条件)">
                                {getFieldDecorator('filDate')(<RangePicker placeholder="选择时间" />)}
                            </FormItem>
                        </Col>
                        
                        {/* <Col span={24}>
                            <FormItem {...formItemLayout} label="随机溢出">
                                {getFieldDecorator('minRandomOverFlowRate', {
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入整数',
                                            pattern: /^\d+$/,
                                        },
                                    ],
                                })(<Input style={{ width: '30%' }} />)}
                                &nbsp;-&nbsp;
                                {getFieldDecorator('maxRandomOverFlowRate', {
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入整数',
                                            pattern: /^\d+$/,
                                        },
                                    ],
                                })(<Input style={{ width: '30%' }} />)}
                            </FormItem>
                        </Col> */}
                        {/* <Col span={24}>
                            <FormItem {...formItemLayout} label="强制互动">
                                {getFieldDecorator('forceInteraction')(
                                    <RadioGroup>
                                        <Radio value={0}>关闭</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                        </Col> */}
                    </Row>
                    <FormItem {...formItemLayout} label="是否是外部任务">
                        {getFieldDecorator('isOutAd')(
                            <Select>
                                <Option value={0}>否</Option>
                                <Option value={1}>是</Option>
                            </Select>,
                        )}
                    </FormItem>
                    {taskType === 'APP_RETAIN' || taskType === 'APPLAUNCH' ? (
                        <div>
                            <FormItem {...formItemLayout} label="是否打码">
                                {getFieldDecorator('needHitCode')(
                                    <Select>
                                        <Option value={0}>否</Option>
                                        <Option value={1}>是</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="是否接码">
                                {getFieldDecorator('needReceiveCode')(
                                    <Select>
                                        <Option value={0}>否</Option>
                                        <Option value={1}>是</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="代理模式">
                                {getFieldDecorator('proxyModel')(
                                    <Select>
                                        <Option value={0}>VPN</Option>
                                        <Option value={1}>SYSPOXY</Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </div>
                    ) : (
                        ''
                    )}
                    <FormItem {...formItemLayout} label="外部任务分类">
                        {getFieldDecorator('outType')(
                            <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                {outTaskCategoryList.map((outTaskCategory, index) => {
                                    return (
                                        <Option
                                            key={outTaskCategory.categoryId}
                                            title={outTaskCategory.name}
                                            value={outTaskCategory.categoryId}>
                                            {outTaskCategory.name}
                                        </Option>
                                    );
                                })}
                            </Select>,
                            // <Select>
                            //     <Option value={1}>F+</Option>
                            //     <Option value={2}>其他外部任务</Option>
                            // </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="安卓ios 分离">
                        {getFieldDecorator('iosAndroidIPSame', {})(
                            <Select>
                                <Option value={0}>否</Option>
                                <Option value={1}>是</Option>
                            </Select>,
                        )}
                    </FormItem>
                    {taskType === 'COMBINE_EV_CLICK' ? (
                        <div>
                            <FormItem {...formItemLayout} label="点击目标量">
                                {getFieldDecorator('clickTargetPv', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入点击目标量',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="是否点击任务">
                                {getFieldDecorator('isEvClick', {
                                    rules: [{ required: true, message: '请选择' }],
                                })(
                                    <Select>
                                        <Option value={0}>否</Option>
                                        <Option value={1}>是</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="ip利用次数">
                                {getFieldDecorator('clickIpReusedTimes', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入ip利用次数',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="点击等待时长">
                                {getFieldDecorator('clickWaitTimeout', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入点击等待时长',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                        </div>
                    ) : (
                        ''
                    )}
                    <FormItem {...formItemLayout} label="APP唤醒方式">
                        {getFieldDecorator('appWake')(
                            <Select>
                                <Option value={0}>h5</Option>
                                <Option value={1}>Dpl拉起</Option>
                                <Option value={2}>Ulk拉起</Option>
                                {/* <Option value="0">h5</Option>
                        <Option value="1">Dpl拉起</Option> */}
                            </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="成功判定标准">
                        {getFieldDecorator('succStandard')(
                            <Select>
                                <Option value={0}>无</Option>
                                <Option value={1}>UTDID</Option>
                            </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="指定设备号前缀">
                        {getFieldDecorator('deviceRedisKeyPreFix')(<Input />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label="UA标识">
                        {getFieldDecorator('uaFlag')(
                            <Select>
                                <Option value={1}>ZhiHu</Option>
                                <Option value={2}>BV</Option>
                                <Option value={3}>YK</Option>
                                <Option value={4}>YD</Option>
                                <Option value={5}>MX</Option>
                                <Option value={6}>M7</Option>
                                <Option value={7}>Y8</Option>
                                <Option value={8}>P4</Option>
                                <Option value={9}>tT</Option>
                                <Option value={10}>Mogo</Option>
                            </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="任务来源">
                        {getFieldDecorator('taskSource', {})(
                            <RadioGroup onChange={this.changeTaskSource}>
                                <Radio value={'ifengad'}>IFENGAD</Radio>
                                <Radio value={'dmp'}>DMP</Radio>
                                <Radio value={'api'}>API</Radio>
                                <Radio value={'dol'}>传漾</Radio>
                                <Radio value={'accurateOperations'}>精准运营</Radio>
                                <Radio value={'lookalike'}>追投</Radio>
                                <Radio value={'js'}>脚本投放</Radio>
                                <Radio value={'brandDsp'}>brandDsp</Radio>
                                {/* <Radio value={'applaunch'}>APP拉起</Radio> */}
                            </RadioGroup>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="app包名">
                        {getFieldDecorator('packageName', {})(<Input />)}
                    </FormItem>
                
                    <FormItem {...formItemLayout} label="账号信息">
                        {getFieldDecorator('accountKey', {})(
                            <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                {accountList.map((item, index) => {
                                    return (
                                        <Option key={index} value={item.redisKey}>
                                            {item.accountName}
                                        </Option>
                                    );
                                })}
                            </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="留存比例">
                        {getFieldDecorator('retainRatio', {
                            rules: [
                                {
                                    pattern: /^\d+$/,
                                    message: '请输入正确的留存比例',
                                },
                            ],
                        })(<Input />)}
                    </FormItem>
                    {this.state.taskSource == 'accurateOperations' || this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="是否获取素材">
                            {getFieldDecorator('requestElement', {})(
                                <RadioGroup>
                                    <Radio value={0}>开启</Radio>
                                    <Radio value={1}>关闭</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                    ) : null}
                    {this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="追投任务Id">
                            {getFieldDecorator('lookalikeTaskId', {})(<Input />)}
                        </FormItem>
                    ) : null}
                    {this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="追投订单Id">
                            {getFieldDecorator('lookalikeOrderId', {})(<Input />)}
                        </FormItem>
                    ) : null}
                    <FormItem {...formItemLayout} label="设备Id利用次数">
                        {getFieldDecorator('deviceIdReusedTimes', {
                            rules: [
                                {
                                    pattern: /^\d+$/,
                                    message: '请输入正确利用次数',
                                },
                            ],
                        })(<Input style={{ width: '50%' }} />)}
                        {getFieldDecorator('deviceIdDiffByTaskOrEid', {})(
                            <Select placeholder="控制域" style={{ width: '50%' }}>
                                <Option value={0}>根据taskId</Option>
                                <Option value={1}>根据eId</Option>
                                <Option value={2}>用完即删</Option>
                                <Option value={3}>按周控制</Option>
                                <Option value={4}>根据广告位</Option>
                                <Option value={5}>联合控制</Option>
                                <Option value={6}>只用历史号</Option>
                                <Option value={7}>历史号最低频次</Option>
                            </Select>,
                        )}
                    </FormItem>
                    {this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="追投标签">
                            {getFieldDecorator('lookalikeTag', {})(<Input />)}
                        </FormItem>
                    ) : null}
                    {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="API">
                            {getFieldDecorator('api', {
                                rules: [
                                    {
                                        //pattern: /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                                        required: false,
                                        message: '请输入api',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                    ) : null}

                    {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                        //     <FormItem {...formItemLayout} label="是否回传">
                        //     {getFieldDecorator('passBack')(
                        //         <RadioGroup>
                        //             <Radio value={0}>是</Radio>
                        //             <Radio value={1}>否</Radio>
                        //         </RadioGroup>,
                        //     )}
                        // </FormItem>
                        <FormItem {...formItemLayout} label="点击回传">
                            {getFieldDecorator('isClickPassBack')(
                                <RadioGroup>
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                    ) : null}
                    {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="曝光回传">
                            {getFieldDecorator('isEvPassBack')(
                                <RadioGroup>
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                    ) : null}


                    {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="是否串行">
                            {getFieldDecorator('isBunchExecute')(
                                <RadioGroup>
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                    ) : null}
                    {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="是否首条先执行">
                            {getFieldDecorator('isFirstExecute')(
                                <RadioGroup>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                    ) : null}

                    {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="素材是否使用真实ip">
                            {getFieldDecorator('isApiMaterialUseRealIp')(
                                <RadioGroup>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                    ) : null}

                    {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="时间间隔">
                            {getFieldDecorator('evClickIntervalTime', {
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                    ) : null}


                    {this.state.taskSource == 'accurateOperations' || this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="兴趣">
                            {getFieldDecorator('interest', {
                                rules: [
                                    {
                                        required: false,
                                        message: '至少选择一个标签',
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="兴趣"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                // onChange={this.handleInterstChange.bind(this)}
                                >
                                    {labelList
                                        .filter((label, index) => {
                                            return label.type == 'i';
                                        })
                                        .map((label, index) => {
                                            return (
                                                <Option key={label.id} title={label.labelName} value={label.id}>
                                                    {label.labelName}
                                                </Option>
                                            );
                                        })}
                                </Select>,
                            )}
                        </FormItem>
                    ) : null}
                    {this.state.taskSource == 'accurateOperations' || this.state.taskSource == 'lookalike' ? (
                        <FormItem {...formItemLayout} label="用户信息">
                            {getFieldDecorator('userInfo', {
                                rules: [
                                    {
                                        required: false,
                                        message: '至少选择一个标签',
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="用户信息"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                // onChange={this.handleUserInfoChange.bind(this)}
                                >
                                    {labelList
                                        .filter((label, index) => {
                                            return label.type == 's';
                                        })
                                        .map((label, index) => {
                                            return (
                                                <Option key={label.id} title={label.labelName} value={label.id}>
                                                    {label.labelName}
                                                </Option>
                                            );
                                        })}
                                </Select>,
                            )}
                        </FormItem>
                    ) : null}

                    <FormItem {...formItemLayout} label="平台">
                        {getFieldDecorator('platform', {
                            rules: [{ message: '请选择设备类型' }],
                        })(
                            <Select>
                                <Option value="APP">APP</Option>
                                <Option value="WAP">WAP</Option>
                                <Option value="PC">PC</Option>
                                <Option value="OTT">OTT</Option>
                                <Option value="PAD">PAD</Option>
                            </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="设备类型">
                        {getFieldDecorator('deviceInfo', {
                            rules: [{ message: '请选择设备类型' }],
                        })(
                            <Select>
                                <Option value="DEFAULT">默认</Option>
                                <Option value="ANDROID">安卓</Option>
                                <Option value="IPHONE">IOS</Option>
                            </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="安卓占比">
                        {getFieldDecorator('androidRatio', {
                            rules: [
                                {
                                    pattern: /^\d+$/,
                                    message: '格式不正确',
                                },
                            ],
                        })(<Input />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label="曲线基准">
                        {getFieldDecorator('curve', {
                            rules: [
                                {
                                    required: false,
                                },
                            ],
                        })(
                            <Select allowClear placeholder="曲线基准" style={{ width: 200 }}>
                                {curveList.map((item, index) => {
                                    return (
                                        <Option key={index} value={item}>
                                            {item}
                                        </Option>
                                    );
                                })}
                            </Select>,
                            // <Select
                            //     multiple
                            //     placeholder="曲线基准"
                            //     allowClear
                            //     optionFilterProp="children"
                            //     filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            // >
                            //     {curveList.length > 0 ? curveList.map((label, index) => {
                            //         return <Option key={label} title={label} value={label}>{label}</Option>
                            //     }) : null}
                            // </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="结束方式">
                        {getFieldDecorator('endType', {
                            //initialValue: null
                        })(
                            <Select placeholder="结束方式" style={{ width: '50%' }}>
                                <Option value={0}>无</Option>
                                <Option value={1}>到量即止</Option>
                                <Option value={2}>无填充</Option>
                            </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="URL">
                        {getFieldDecorator('url', {
                            // rules: [
                            //     {
                            //         pattern: /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                            //         required: false,
                            //         message: '请输入url',
                            //     },
                            // ],
                        })(<Input />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label="目标量">
                        {getFieldDecorator('targetPv', {
                            rules: [
                                {
                                    required: false,
                                    message: '请输入正确目标量',
                                    pattern: /^\d+$/,
                                },
                            ],
                        })(<Input />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label="时间段">
                        {/* {getFieldDecorator('beginTime', {
                    rules: [{ type: 'object', require: true, message: '请选择开始时间' }],
                })(<TimePicker format="HH:mm" />)}
                {getFieldDecorator('endTime', {
                    rules: [{ type: 'object', require: true, message: '请选择结束时间' }],
                })(<TimePicker format="HH:mm" style={{ padding: '0 0 0 10px' }} />)} */}
                        {getFieldDecorator('timePairs', {
                            initialValue: [{ beginTime: 0, endTime: 0 }],
                        })(<TimePairsSelect />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label="启用时间">
                        {getFieldDecorator('filtration')(<RangePicker placeholder="选择时间" />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label="强制到达">
                        {getFieldDecorator('forceArrive', {
                            //initialValue: null,
                        })(
                            <RadioGroup>
                                <Radio value={0}>关闭</Radio>
                                <Radio value={1}>开启</Radio>
                            </RadioGroup>,
                        )}
                    </FormItem>

                    <FormItem {...formItemLayout} label="S2S">
                        {getFieldDecorator('isS2S', {
                        })(
                            <RadioGroup >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                            </RadioGroup>,
                        )}
                    </FormItem>

                    <FormItem {...formItemLayout} label="线索信息">
                        {getFieldDecorator('clue', {
                            rules: [
                                {
                                    required: false,
                                    message: '输入线索信息',
                                },
                            ],
                        })(<Input />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label="溢出量">
                        {getFieldDecorator('overflowRate', {
                            //initialValue: null,
                            rules: [
                                {
                                    required: false,
                                    message: '请输入溢出量',
                                    pattern: /^\d+$/,
                                },
                            ],
                        })(
                            <RadioGroup onChange={this.changeFlow}>
                                <Radio value={10}>10%</Radio>
                                <Radio value={20}>20%</Radio>
                                <Radio value={30}>30%</Radio>
                                <Radio value={40}>自定义</Radio>
                            </RadioGroup>,
                        )}
                    </FormItem>
                    {this.state.overflowRate == 40 ? (
                        <FormItem {...formItemLayout} label="自定义溢出比例">
                            {getFieldDecorator('overflow', {
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入溢出量百分比，如10',
                                        //pattern: /^\d+$/,
                                    },
                                ],
                            })(<Input placeholder="请填入比例，如10" />)}
                        </FormItem>
                    ) : null}
                    <FormItem {...formItemLayout} label="随机溢出(根据taskId)">
                        {getFieldDecorator('minRandomOverFlowRate', {
                            rules: [
                                {
                                    required: false,
                                    message: '请输入整数',
                                    pattern: /^\d+$/,
                                },
                            ],
                        })(<Input style={{ width: '30%' }} />)}
                        &nbsp;-&nbsp;
                        {getFieldDecorator('maxRandomOverFlowRate', {
                            rules: [
                                {
                                    required: false,
                                    message: '请输入整数',
                                    pattern: /^\d+$/,
                                },
                            ],
                        })(<Input style={{ width: '30%' }} />)}
                    </FormItem>

                    <FormItem {...formItemLayout} label="溢出标准值">
                        {getFieldDecorator('standardOverflowRate', {
                            rules: [
                                {
                                    required: false,
                                    pattern: /^\d+$/,
                                },
                            ],
                        })(<Input style={{ width: '20%' }} />)}
                        &nbsp;&nbsp;&nbsp;down:&nbsp;
                        {getFieldDecorator('reduceFlowRate', {})(<Input style={{ width: '20%' }} />
                        )}&nbsp;up:&nbsp;
                        {getFieldDecorator('addFlowRate', {})(<Input style={{ width: '20%' }} />
                        )}
                    </FormItem>

                    <FormItem {...formItemLayout} label="ivt阈值">
                        {getFieldDecorator('ivt', {
                            rules: [
                                {
                                    required: false,
                                    message: '请输入正确ivt阈值',
                                    pattern: /^\d+$/,
                                },
                            ],
                        })(<Input style={{ width: '50%' }} />)}
                        {getFieldDecorator('realTimeIvt', {})(
                            <Select placeholder="是否实时" style={{ width: '50%' }}>
                                <Option value={0}>不实时</Option>
                                <Option value={1}>实时</Option>
                            </Select>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="启用截图">
                        {getFieldDecorator('screenshots')(
                            <RadioGroup>
                                <Radio value={0}>关闭</Radio>
                                <Radio value={1}>开启</Radio>
                            </RadioGroup>,
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="定向省份">
                        {getFieldDecorator('provinces', {
                            //initialValue: [],
                            rules: [
                                {
                                    required: false,
                                },
                            ],
                        })(
                            <Select
                                multiple
                                placeholder="投放省份"
                                allowClear
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }>
                                {provinceList.map((province, index) => {
                                    return (
                                        <Option key={province.id} title={province.name} value={province.id}>
                                            {province.name}
                                        </Option>
                                    );
                                })}
                            </Select>,
                        )}
                    </FormItem>

                    <FormItem {...formItemLayout} label="非定向省份">
                        {getFieldDecorator('excludeProvinces', {
                            //initialValue: [],
                            rules: [
                                {
                                    required: false,
                                },
                            ],
                        })(
                            <Select
                                multiple
                                placeholder="非投放省份"
                                allowClear
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }>
                                {provinceList.map((province, index) => {
                                    return (
                                        <Option key={province.id} title={province.name} value={province.id}>
                                            {province.name}
                                        </Option>
                                    );
                                })}
                            </Select>,
                        )}
                    </FormItem>

                    <FormItem {...formItemLayout} label="所属集群">
                        {getFieldDecorator('belongCluster', {
                            //initialValue: null ,
                        })(
                            <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                {clusterList.map((item, index) => {
                                    return (
                                        <Option key={index} value={item}>
                                            {item}
                                        </Option>
                                    );
                                })}
                            </Select>,
                        )}
                    </FormItem>

                    <div style={{ display: this.state.role == 1 ? 'block' : 'none' }}>
                        <FormItem {...formItemLayout} label="等待时长(内层)">
                            {getFieldDecorator('waitTimeout', {
                                //initialValue: null,
                                rules: [
                                    {
                                        message: '请输入正确等待时长（s）',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="代理有效时长">
                            {getFieldDecorator('forceWait', {
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入代理有效时长数值',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="UV占比">
                            {getFieldDecorator('pvToUvRatio', {
                                //initialValue: null,
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确UV占比',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="利用次数">
                            {getFieldDecorator('ipReusedTimes', {
                                //initialValue: null,
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确利用次数',
                                    },
                                ],
                            })(<Input style={{ width: '50%' }} />)}
                            {getFieldDecorator('ipDiffByTaskOrEid', {})(
                                <Select placeholder="控制域" style={{ width: '50%' }}>
                                    <Option value={0}>根据taskId</Option>
                                    <Option value={1}>根据eId</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="ip使用范围">
                            {getFieldDecorator('ipRange', {})(
                                <Select>
                                    <Option value="0">全部ip</Option>
                                    <Option value="1">去除黑名单ip</Option>
                                    <Option value="2">IP地域过滤</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="ip利用次数单位时间">
                            {getFieldDecorator('ipInterval', {
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确的单位时间',
                                    },
                                ],
                            })(<InputNumber />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="单位时间ip利用次数">
                            {getFieldDecorator('ipUnitReuseTimes', {
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确的ip利用次数',
                                    },
                                ],
                            })(<InputNumber />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="引擎">
                            {getFieldDecorator('engine', {})(
                                <Select allowClear onChange={this.handleEngine.bind(this)} style={{ width: 200 }}>
                                    <Option value="PHANTOMJS">PhantomJS</Option>
                                    <Option value="CHROME">Chrome</Option>
                                    <Option value="CHROMIUM">Chromium</Option>
                                    <Option value="APP">App</Option>
                                    <Option value="APPLAUNCH">AppLaunch</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="主脚本地址">
                            {getFieldDecorator('mainScriptPath', {
                                //initialValue: null,
                                rules: [{ required: false, message: '请选择类型' }],
                            })(
                                <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {primaryScripts
                                        .filter((item, index) => {
                                            let engine = this.state.engine;
                                            if (engine === 'CHROMIUM') {
                                                engine = 'CHROME';
                                            }
                                            return item.source == engine;
                                        })
                                        .map((item, index) => {
                                            return (
                                                <Option key={index} value={item.path}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="脚本地址">
                            {getFieldDecorator('scriptPath', {
                                //initialValue: null,
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入脚本地址',
                                    },
                                ],
                            })(
                                <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {otherScripts
                                        .filter((item, index) => {
                                            let engine = this.state.engine == 'PHANTOMJS' ? 'PHANTOMJS' : 'CHROME';
                                            return item.source == engine;
                                        })
                                        .map((item, index) => {
                                            return (
                                                <Option key={index} value={item.path}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="客户端分组id">
                            {getFieldDecorator('groupId', {
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确的分组id',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="referer">
                            {getFieldDecorator('referer', {
                                //initialValue: null,
                                rules: [
                                    {
                                        message: '请输入referer',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="完成标记">
                            {getFieldDecorator('finishedFlag', {
                                //initialValue: null,
                                rules: [
                                    {
                                        message: '请输入完成标记',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="请求类型">
                            {getFieldDecorator('requestType', {
                                //initialValue: null,
                            })(
                                <Select>
                                    <Option value="WEBKIT">WEBKIT</Option>
                                    <Option value="HTTP_CLIENT">HTTP_CLIENT</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <Row style={{ position: 'relative' }} gutter={2} style={{ marginBottom: '20px' }}>
                            <Col span={6} style={{ fontSize: '12px', lineHeight: '32px', textAlign: 'right' }}>
                                请输入行为数据：
                            </Col>
                            <Col span={14}>
                                <TextArea value={this.state.behaviourData} onChange={this.changeBehaviourData} />
                            </Col>
                            <Col span={2} style={{ marginLeft: '6px' }}>
                                <Button type="danger" onClick={this.showBehaviourEdit}>
                                    转换
                                </Button>
                            </Col>
                        </Row>
                        <FormItem {...formItemLayout} label="行为互动比例">
                            {getFieldDecorator('activeProportion', {
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确的行为互动比例',
                                    },
                                ],
                            })(<Input addonAfter="%" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="互动执行延时">
                            {getFieldDecorator('behaviourDataWaitTime', {
                                rules: [
                                    {
                                        pattern: /\d+/,
                                        message: '请输入数字',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否清空行为数据" >
                            {getFieldDecorator('isClearBehaviourData')(
                                <RadioGroup>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="监测代码请求期望数">
                            {getFieldDecorator('irCountExcept', {
                                initialValue: '',
                                rules: [
                                    {
                                        pattern: /\d+/,
                                        message: '请输入数字',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="关联taskId">
                            {getFieldDecorator('connectTaskIds', {
                                initialValue: '',
                                rules: [
                                    {
                                        message: '关联taskId',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="执行速度系数">
                            {getFieldDecorator('speedRatio', {
                                initialValue: null,
                            })(
                                <Select>
                                    <Option value={40}>40%</Option>
                                    <Option value={60}>60%</Option>
                                    <Option value={80}>80%</Option>
                                    <Option value={100}>100%</Option>
                                    <Option value={120}>120%</Option>
                                    <Option value={140}>140%</Option>
                                    <Option value={160}>160%</Option>
                                    <Option value={180}>180%</Option>
                                    <Option value={200}>200%</Option>
                                    <Option value={220}>220%</Option>
                                    <Option value={240}>240%</Option>
                                    <Option value={260}>260%</Option>
                                    <Option value={280}>280%</Option>
                                    <Option value={300}>300%</Option>
                                    <Option value={500}>500%</Option>
                                    <Option value={800}>800%</Option>
                                    <Option value={1000}>1000%</Option>
                                    <Option value={2000}>2000%</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="追踪取样比例(%)">
                            {getFieldDecorator('trackingSamplingRatio', {
                                initialValue: null,
                                rules: [
                                    {
                                        message: '取值为0-100',
                                        pattern: /^(?:[1-9]?\d|100)$/,
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="点击率">
                            {getFieldDecorator('clickRate', {
                                initialValue: '',
                                rules: [
                                    {
                                        pattern: /\d+/,
                                        message: '请输入数字',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="点击率分组">
                            {getFieldDecorator('clickRateFlag', {
                                initialValue: '',
                                rules: [
                                    {
                                        message: '请输入',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="任务关联关键字">
                            {getFieldDecorator('connectKey', {
                                initialValue: '',
                            })(
                                <Select>
                                    <Option value="splash_gdt">splash_gdt</Option>
                                    <Option value="splash_csj">splash_csj</Option>
                                    <Option value="banner_gdt">banner_gdt</Option>
                                    <Option value="banner_csj">banner_csj</Option>
                                    <Option value="flow_gdt">flow_gdt</Option>
                                    <Option value="flow_csj">flow_csj</Option>
                                    <Option value="pop_gdt">pop_gdt</Option>
                                    <Option value="pop_csj">pop_csj</Option>
                                    <Option value="">空</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="到达率">
                            {getFieldDecorator('hzArrivalRate', {
                                initialValue: '',
                                rules: [
                                    {
                                        pattern: /\d+/,
                                        message: '请输入数字',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="指定代理商">
                            {getFieldDecorator('appointProxyName')(
                                <Select
                                    multiple
                                    placeholder="代理商"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {agents.map((item, index) => {
                                        return (
                                            <Option key={index} title={item} value={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="排除代理商">
                            {getFieldDecorator('excludeProxyName')(
                                <Select
                                    multiple
                                    placeholder="排除-代理商"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {agents.map((item, index) => {
                                        return (
                                            <Option key={index} title={item} value={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="独享代理池">
                            {getFieldDecorator('exclusiveProxy')(
                                // <RadioGroup>
                                //     <Radio value={0}>关闭</Radio>
                                //     <Radio value={1}>开启</Radio>
                                // </RadioGroup>, 
                                <Select>
                                  <Option value={0}>关闭</Option>
                                  <Option value={1}>开启(taskId)</Option>
                                  <Option value={2}>开启(eId)</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="总量控制">
                            {getFieldDecorator('tc')(
                                <RadioGroup>
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="忽略阻塞限制">
                            {getFieldDecorator('ignoreThreshold')(
                                <RadioGroup>
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="分配方式">
                            {getFieldDecorator('onTargetPv')(
                                <RadioGroup>
                                    <Radio value={0}>余量分配</Radio>
                                    <Radio value={1}>总量分配</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="禁用图片">
                            {getFieldDecorator('disableImg')(
                                <RadioGroup>
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否追投">
                            {getFieldDecorator('isAdditional')(
                                <RadioGroup>
                                <Radio value={0}>否</Radio>
                                <Radio value={1}>按设备ID</Radio>
                                <Radio value={2}>按IP</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否重写Canvas">
                            {getFieldDecorator('isOverwriteCanvas')(
                                <RadioGroup>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="异步请求">
                            {getFieldDecorator('isAsynRequest')(
                                <RadioGroup>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="强制互动">
                            {getFieldDecorator('forceInteraction')(
                                <RadioGroup>
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="检测公司预警">
                            {getFieldDecorator('interactionAlarm')(
                                <RadioGroup>
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="自动修改溢出">
                            {getFieldDecorator('autoUpdateOverFlowRate')(
                                <RadioGroup>
                                    <Radio value={0}>禁用</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="执行脚本">
                            {getFieldDecorator('executeScript')(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="脚本互动比例">
                            {getFieldDecorator('shellProportion', {
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确的脚本互动比例',
                                    },
                                ],
                            })(<Input addonAfter="%" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="附加信息">
                            {getFieldDecorator('dependentType', {
                                rules: [
                                    {
                                        pattern: /\d+/,
                                        message: '请输入数字',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否回传安卓id">
                            {getFieldDecorator('isAndroidIdPassBack', {
                            })(
                                <RadioGroup>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否回传Mac">
                            {getFieldDecorator('isMacPassBack', {
                            })(
                                <RadioGroup>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否回传oaId">
                            {getFieldDecorator('isOaIdPassBack', {
                            })(
                                <RadioGroup>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="素材格式预警">
                            {getFieldDecorator('materialFormatWarning')(
                                <Select>
                                    <Option value={0}>关闭</Option>
                                    <Option value={1}>打开</Option>
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="期望溢出">
                            {getFieldDecorator('expectOverFlow', {
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="请求是否获取360参数">
                            {getFieldDecorator('needRequestData', {})(
                                <Select>
                                    <Option value={0}>不需要</Option>
                                    <Option value={1}>需要</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="检测公司">
                            {getFieldDecorator('monitorNames', {
                                rules: [
                                    {
                                        required: false,
                                        message: '至少选择一个标签',
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="检测公司"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {moniterNameListClone.map((label, index) => {
                                        return (
                                            <Option
                                                key={label.monitoringName}
                                                title={label.monitoringName}
                                                value={label.monitoringName}>
                                                {label.monitoringName}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="责任人">
                            {getFieldDecorator('principal')(
                                <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {userList.map((item, index) => {
                                        return (
                                            <Option key={index} value={item.name}>
                                                {item.name}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>
                    </div>
                    <BehaviourMask
                        behaviourData={this.state.behaviourData}
                        editBehavior={editBehavior}
                        hideBehaviorMask={this.hideBehaviorMask}
                        changeEditInfo={this.changeEditInfo}
                    />
                </div>
            </Form>


        );

        return (
            <span>
                <Modal
                    width={800}
                    title="整单编辑"
                    visible={this.props.taskOverFlowStatu}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={this.props.taskOverFlowStatuLoding} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    taskOverFlowStatuLoding: state.tasklist.ListStatus.taskOverFlowStatuLoding,
    taskOverFlowStatu: state.tasklist.ListStatus.taskOverFlowStatu,

    taskIdList: state.tasklist.taskIdList,
    //bulkStatus: state.tasklist.ListStatus.bulkupdatetask,
    provinceList: state.tasklist.ProvinceList,
    primaryScripts: state.tasklist.primaryScripts,
    otherScripts: state.tasklist.otherScripts,
    clusterList: state.tasklist.ClusterList,
    outTaskCategoryList: state.tasklist.OutTaskCategoryList,
    agents: state.tasklist.agents,
    labelList: state.tasklist.LabelList,
    curveList: state.tasklist.curveList,
    userList: state.tasklist.UserList, //用户列表
    moniterNameList: state.tasklist.moniterNameList,
    accountList: state.tasklist.accountList,
});

const mapDispatchToProps = dispatch => ({
    getList: param => dispatch(getList(param)),
    editTaskOverflowStatus: status => dispatch(editTaskOverflowStatus(status)),
    ayncSetTaskOverFlow: data => dispatch(ayncSetTaskOverFlow(data)),

    //getList: param => dispatch(getList(param)),
    //changeShowStatus: status => dispatch(createbulkUpdateShowTaskAction(status)),
    //setTaskList: list => dispatch(createSetTaskIdListAction(list)),
    //bulkUpdate: param => dispatch(bulkToMD(param)),
    //getProvinceList: () => dispatch(getProvinceList()),
    //getScripts: () => dispatch(getPrimaryAndOtherScript()),
    // getClusterList: () => dispatch(getClusterList()),
    //getOutTaskCategoryList: () => dispatch(getOutTaskCategoryList()),
    //getAgentsAndAreas: () => dispatch(getAgentsAndAreas()),
    //getLabelList: () => dispatch(getLabelList()),
    //getMonitorList: () => dispatch(getMonitorList()),
    //getCurveList: () => dispatch(getCurveList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(EditOverFlow));



// WEBPACK FOOTER //
// ./pages/task/tasklist/editOverflow.js